import * as React from 'react'

import { Box, Icon, Table, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import type Field from 'modules/custom_resources/store/models/customResources/Field'
import type Schema from 'modules/custom_resources/store/models/customResources/Schema'
import type Value from 'modules/custom_resources/store/models/customResources/Value'
import { getValue } from 'modules/employees/components/CustomResources/SchemaComponent/utils/getValue'
import { RouteContext } from 'modules/employees/pages/CustomTablesListPage/context'

interface Props {
  attachableId: number
  schema: Schema
  fields: Field[]
  value: Value
}

const TableBodyRowComponent = ({ schema, fields, value }: Props) => {
  const rootRoute = React.useContext(RouteContext)

  const {
    company: { locale: companyLocale },
  } = useCurrentSession()

  if (!rootRoute) return null

  const goToEdit = (valueId: number) => {
    return rootRoute.customTablesEdit(schema.attributes.id, String(valueId))
  }

  const itemValue = (value: Value, field: Field) =>
    getValue({
      schema,
      field,
      currentValue: value,
      companyLocale: companyLocale || '',
    })

  return (
    <Table.Row.Router to={goToEdit(value.attributes.id)}>
      {fields.map((field, key) => (
        <Table.Cell key={key}>
          <Text.Normal size="300" weight="normal" color="grey800">
            {itemValue(value, field)}
          </Text.Normal>
        </Table.Cell>
      ))}
      <Table.Cell>
        <Box alignItems="flexEnd">
          <Icon.Medium icon="arrow-right" color="grey600" />
        </Box>
      </Table.Cell>
    </Table.Row.Router>
  )
}

export default observer(TableBodyRowComponent)
